import React from 'react'
import { Route, Switch } from 'react-router-dom'
import PrivateAmenityServiceRoute from '../../../policy/PrivateAmenityServiceRoute'
import PublicAmenityServiceRoute from '../../../policy/PublicAmenityServiceRoute'
import Loadable from './Loadable'

// const AsyncHome = Loadable({
//     loader: () => import(/* webpackChunkName: "Home" */ '../../ui/components/Home')
// })

const AsyncTermAndCondition = Loadable({
    loader: () => import('../../user/components/TermAndCondition')
})

const AsyncNotFound = Loadable({
    loader: () => import(/* webpackChunkName: "NotFound" */ '../../ui/components/NotFound')
})

const AsyncLoginO365 = Loadable({
    loader: () => import(/* webpackChunkName: "LoginO365" */ '../../auth/components/LoginO365')
})

const AsyncAuthorizeO365 = Loadable({
    loader: () => import(/* webpackChunkName: "AuthorizeO365" */ '../../auth/components/AuthorizeO365')
})

const AsyncHomeMenu = Loadable({
    loader: () => import('../../ui/components/HomeMenu')
})

const AsyncTimeSlot = Loadable({
    loader: () => import('../../ui/components/TimeSlot')
})

const AsyncCreate = Loadable({
    loader: () => import('../../ui/components/Create')
})

const AsyncReservationFor = Loadable({
    loader: () => import('../../ui/components/ReservationFor')
})

const AsyncAttendee = Loadable({
    loader: () => import('../../ui/components/Attendee')
})

const AsyncAttendeeEdit = Loadable({
    loader: () => import('../../ui/components/AttendeeEdit')
})

const AsyncOrder = Loadable({
    loader: () => import('../../orders/components/Orders')
})

const AsyncCreateOrder = Loadable({
    loader: () => import('../../orders/components/CreateOrder')
})

const AsyncEditOrder = Loadable({
    loader: () => import('../../orders/components/EditOrder')
})

const AsyncOrderEdit = Loadable({
    loader: () => import('../../ui/components/OrderEdit')
})

// const AsyncAmenity = Loadable({
//     loader: () => import('../../ui/components/Amenity')
// })

const AsyncAmenityEdit = Loadable({
    loader: () => import('../../ui/components/AmenityEdit')
})

const AsyncConfirm = Loadable({
    loader: () => import('../../ui/components/Confirm')
})

const AsyncMyReservationComing = Loadable({
    loader: () => import('../../ui/components/MyreservationComing')
})

const AsyncMyReservationHistory = Loadable({
    loader: () => import('../../ui/components/MyreservationHistory')
})

const AsyncMyReservationDay = Loadable({
    loader: () => import('../../ui/components/MyreservationDay')
})

const AsyncEdit = Loadable({
    loader: () => import('../../ui/components/EditEvent')
})

const AsyncQrcode = Loadable({
    loader: () => import('../../ui/components/Qrcode')
})

const AsyncCheckInSuccess = Loadable({
    loader: () => import('../../ui/components/CheckInSuccess')
})

const AsyncCheckOutSuccess = Loadable({
    loader: () => import('../../ui/components/CheckOutSuccess')
})

const AsyncCheckOutFail = Loadable({
    loader: () => import('../../ui/components/CheckOutFail')
})

const AsyncCheckInFail = Loadable({
    loader: () => import('../../ui/components/CheckInFail')
})

const AsyncFloorPlan = Loadable({
    loader: () => import('../../ui/components/FloorPlan')
})

const AsyncInformation = Loadable({
    loader: () => import('../../user/components/Information')
})

const AsyncAccessDenied = Loadable({
    loader: () => import('../../ui/components/AccessDenied')
})

const AsyncLogin = Loadable({
    loader: () => import('../../user/components/Login')
})

const AsyncLoginADFS = Loadable({
    loader: () => import('../../auth/components/LoginADFS')
})

const VerifyOauth = Loadable({
    loader: () => import('../../user/components/VerifyOauth')
})

const AsyncSearchRoom = Loadable({
    loader: () => import('../../ui/components/SearchRoom')
})

const AsyncReservationForEdit = Loadable({
    loader: () => import('../../ui/components/ReservationForEdit')
})

const AsyncEventHistory = Loadable({
    loader: () => import('../../ui/components/EventHistory')
})

const AsyncFloorPlanNew = Loadable({
    loader: () => import('../../floors/components/FloorPlan')
})

// const AsynRoomSlots = Loadable({
//     loader: () => import('../../rooms/components/RoomSlot')
// })

const AsynSlot = Loadable({
    loader: () => import('../../rooms/components/Slot')
})
// const AsynRoomSlotsID = Loadable({
//     loader: () => import('../../rooms/components/RoomSlotID')
// })

const AsyncSearchRoomSuggest = Loadable({
    loader: () => import('../../rooms/components/SearchRoomSuggest')
})

const AsyndcViewEvent = Loadable({
    loader: () => import('../../events/components/ViewEvent')
})

const AsyndcViewEventScan = Loadable({
    loader: () => import('../../events/components/ViewEventScan')
})

const AsyndcCheckIn = Loadable({
    loader: () => import('../../events/components/CheckIn')
})

const AsyndcCreateEvent = Loadable({
    loader: () => import('../../events/components/CreateEvent')
})

const AsyndcCreateEventTraining = Loadable({
    loader: () => import('../../events/components/CreateEventTraining')
})

const AsyncMyReservationComingNew = Loadable({
    loader: () => import('../../mybookings/components/MyMeetingComing')
})

const AsyncMyReservationHistoryNew = Loadable({
    loader: () => import('../../mybookings/components/MyMeetingHistory')
})

const AsyncMyReservationDayNew = Loadable({
    loader: () => import('../../mybookings/components/MyMeetingCalendar')
})

const AsyncEditEvent = Loadable({
    loader: () => import('../../events/components/EditEvent')
})

const AsyncEditEventTraining = Loadable({
    loader: () => import('../../events/components/EditEventTraining')
})

const AsyncCreateEventSuccess = Loadable({
    loader: () => import('../../events/components/CreateEventSuccess')
})

const AsyncEditEventSuccess = Loadable({
    loader: () => import('../../events/components/EditEventSuccess')
})

const AsyncVerifyBypass = Loadable({
    loader: () => import('../../user/components/VerifyBypass')
})

const AsyncContact = Loadable({
    loader: () => import('../../user/components/Contact')
})

const AsyncRoomQr = Loadable({
    loader: () => import('../../qrcode/components/Qrcode')
})

const AsyncRoomQrIOS = Loadable({
    loader: () => import('../../qrcode/components/QrcodeIOS')
})

const AsyncRoomQrCheckin = Loadable({
    loader: () => import('../../qrcode/components/QrcodeCheckin')
})

// const AsyncSearchRoomName = Loadable({
//     loader: () => import('../../rooms/components/SearchRoomName')
// })

const AsyncSearchRoomNameHome = Loadable({
    loader: () => import('../../rooms/components/SearchRoomNameHome')
})

const AsyncSearchRoomNameResult = Loadable({
    loader: () => import('../../rooms/components/SearchRoomNameResult')
})


const AsyncAmenityService = Loadable({
    loader: () => import('../../amenityandservice/components/AmenityService')
})

const AsyncAmenityServiceLogin = Loadable({
    loader: () => import('../../amenityandservice/components/AmenityServiceLogin')
})

const AsyncViewEvent = Loadable({
    loader: () => import('../../amenityandservice/components/EventDetail')
})



const AsyncFbs = Loadable({
    loader: () => import('../../orders/components/FBS')
})

const AsyncChangePassword = Loadable({
    loader: () => import('../../user/components/ChangePassword')
})

const AsyncFirstChangePassword = Loadable({
    loader: () => import('../../user/components/FirstChangePassword')
})

export default () => (
    <Switch>

        {/* <Route path='/amenityservice' component={AsyncAmenityService} /> */}
        {/* <Route path='/vieworder/:type/:id' component={AsyncViewEvent} /> */}
        <PrivateAmenityServiceRoute path='/amenityservice/vieworder/:type/:id' component={AsyncViewEvent} />
        <PrivateAmenityServiceRoute path='/amenityservice/login' component={AsyncAmenityServiceLogin} />
        <PrivateAmenityServiceRoute path='/amenityservice' component={AsyncAmenityService} />


        {/* <Route exact path='/' component={AsyncHome} /> */}
        <Route path='/verifyoauth' component={VerifyOauth} />

        <Route path='/roomSlots/:path/:id/:date/:start/:end' component={AsynSlot} />
        <Route path='/roomSlots/:path/:id' component={AsynSlot} />
        {/* <Route path='/roomSlots/:id' component={AsynRoomSlotsID} /> */}
        <Route path='/verifybypass/:id/:email' component={AsyncVerifyBypass} />
        <Route path='/loginadfs' component={AsyncLoginADFS} />
        <Route path='/login' component={AsyncLogin} />
        <Route path='/contact' component={AsyncContact} />
        <Route path='/viewterm' component={AsyncTermAndCondition} />
        <Route path='/term' component={AsyncTermAndCondition} />
        <Route path='/logino365' component={AsyncLoginO365} />
        <Route path='/authorize' component={AsyncAuthorizeO365} />
        <Route path='/information' component={AsyncInformation} />
        <Route path='/menu' component={AsyncHomeMenu} />
        <Route path='/qrcode/:room/:event' component={AsyncRoomQrCheckin} />
        <Route path='/qrcodeios' component={AsyncRoomQrIOS} />
        <Route path='/qrcode' component={AsyncRoomQr} />

        <Route path='/orders/:type/:eventId' component={AsyncOrder} />
        <Route path='/createorder/:type/:eventId' component={AsyncCreateOrder} />
        <Route path='/editorder/:type/:eventId/:orderId' component={AsyncEditOrder} />
        <Route path='/fbs/:orderId' component={AsyncFbs} />
        {/* <Route path='/amenity' component={AsyncAmenity} /> */}
        <Route path='/orderEdit' component={AsyncOrderEdit} />
        <Route path='/amenityEdit' component={AsyncAmenityEdit} />


        <Route path='/myreservationHistory' component={AsyncMyReservationHistoryNew} />
        <Route path='/myreservationComing' component={AsyncMyReservationComingNew} />
        <Route path='/myreservationDay' component={AsyncMyReservationDayNew} />
        <Route path='/vieweventScan/:id' component={AsyndcViewEventScan} />
        <Route path='/viewevent/:id' component={AsyndcViewEvent} />
        <Route path='/createevent/:path/:id/:single/:startDate/:endDate/:startTime/:endTime' component={AsyndcCreateEvent} />
        <Route path='/createevent/:path/:id' component={AsyndcCreateEvent} />
        <Route path='/createeventTraining/:path/:id/:single/:startDate/:endDate/:startTime/:endTime' component={AsyndcCreateEventTraining} />
        <Route path='/createeventTraining/:path/:id' component={AsyndcCreateEventTraining} />
        <Route path='/createsuccess/:eventid' component={AsyncCreateEventSuccess} />
        <Route path='/editevent/:type/:id' component={AsyncEditEvent} />
        <Route path='/editeventTraining/:type/:id' component={AsyncEditEventTraining} />
        <Route path='/editsuccess/:eventid' component={AsyncEditEventSuccess} />
        <Route path='/checkin/:id' component={AsyndcCheckIn} />
        <Route path='/floorplan' component={AsyncFloorPlanNew} />
        <Route path='/roomsuggest' component={AsyncSearchRoomSuggest} />
        <Route path='/search/:text' component={AsyncSearchRoomNameResult} />
        <Route path='/search/' component={AsyncSearchRoomNameResult} />


        <Route path='/reset/:email' component={AsyncChangePassword} />
        <Route path='/changepassword/:id' component={AsyncFirstChangePassword} />

        <Route path='/' component={AsyncSearchRoomNameHome} />
        {/* <Route path='/:key' component={AsyncSearchRoomName} />
        <Route path='/' component={AsyncSearchRoomName} /> */}

        {/* 
        <Route path='/demo/timeSlot' component={AsyncTimeSlot} />
        <Route path='/demo/create' component={AsyncCreate} />
        <Route path='/demo/reservationFor' component={AsyncReservationFor} />
        <Route path='/demo/reservationForEdit' component={AsyncReservationForEdit} />
        <Route path='/demo/attendee' component={AsyncAttendee} />
        <Route path='/demo/attendeeEdit' component={AsyncAttendeeEdit} />
        <Route path='/demo/confirm' component={AsyncConfirm} />
        <Route path='/demo/myreservation' component={AsyncMyReservationComing} />
        <Route path='/demo/edit' component={AsyncEdit} />
        <Route path='/demo/qrcode' component={AsyncQrcode} />
        <Route path='/demo/checkinSuccess' component={AsyncCheckInSuccess} />
        <Route path='/demo/checkoutSuccess' component={AsyncCheckOutSuccess} />
        <Route path='/demo/checkinFail' component={AsyncCheckInFail} />
        <Route path='/demo/checkoutFail' component={AsyncCheckOutFail} />
        <Route path='/demo/floorPlan' component={AsyncFloorPlan} />
        <Route path='/demo/accessdenied' component={AsyncAccessDenied} />
        <Route path='/demo/myreservationHistory' component={AsyncMyReservationHistory} />
        <Route path='/demo/myreservationDay' component={AsyncMyReservationDay} />
        <Route path='/demo/view' component={AsyncEventHistory} />
        <Route exact path='/demo' component={AsyncSearchRoom} /> */}

        {/* <Route path='/' component={AsyncSearchRoomName} /> */}
        {/* <Route path='/:key' component={AsyncSearchRoomName} /> */}
        <Route component={AsyncNotFound} />
    </Switch>
)


// WEBPACK FOOTER //
// ./src/features/ui/components/Routes.js